import { useMutation } from "@apollo/client";
import {
  GetOrderByIdDocument,
  UpdateOrderProductDocument,
} from "../../gql/generated/graphql";
import {
  updateProductArgsToInput,
  type UpdateProductArgs,
} from "./productInputs";

interface Props {
  orderId: string;
}

export const useUpdateProduct = ({ orderId }: Props) => {
  const [updateProductMutation, { loading: isUpdating }] = useMutation(
    UpdateOrderProductDocument,
    {
      refetchQueries: [GetOrderByIdDocument],
      awaitRefetchQueries: true,
    }
  );

  const updateProduct = (args: UpdateProductArgs) =>
    updateProductMutation({
      variables: {
        orderId,
        productId: args.productId,
        input: updateProductArgsToInput(args),
      },
    });

  return {
    updateProduct,
    isUpdating,
  };
};
